import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
// import Footer from "../../layout/Footer/Footer";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
  Spinner
} from "reactstrap";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";
import { encode } from "base64-arraybuffer";
import axios from "axios";
import Baja from "../../Baja";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import qrcode from "qrcode-js";
import { v4 as uuidv4 } from "uuid";
import moment from 'moment';
import SelectorArchivos, { subirEnSerie, avisaResultado, nombreDe } from "../../SelectorArchivos";

function ListadoSurtidos() {
  const { user } = useContext(AuthContext);
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_SEND_MAIL_ATT = process.env.REACT_APP_URL_SEND_MAIL_ATT;
  const URL_ARTICULOS_EMBARQUES = process.env.REACT_APP_URL_ARTICULOS_EMBARQUES;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_PAQUETERIAS = process.env.REACT_APP_URL_PAQUETERIAS;
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;

  let hoy = new Date()
  let inicio = new Date()
  inicio.setDate(inicio.getDate()-90);
 
  let endDate   = moment(hoy).format("YYYY-MM-DD"); 
  let startDate   = moment(inicio).format("YYYY-MM-DD");

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedUser, setSelectedUser] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);
  const [autorizadoSurtido, setAutorizadoSurtido] = useState("");

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [activo, setActivo] = useState("");

  const [cargando, setCargando] = useState(true);
  const [modalEntregar, setModalEntregar] = useState(false);
  const toggleEntregar = () => setModalEntregar(!modalEntregar);
  const [paqueterias, setPaqueterias] = useState([]);
  const [selectedPaqueteria, setSelectedPaqueteria] = useState("");
  const [surtidosPaqueteria, setSurtidosPaqueteria] = useState([]);
  const [idsArticulo, setIdsArticulo] = useState([]);
  const [surtidosPaqueteriaGuarda, setSurtidosPaqueteriaGuarda] = useState([]);
  const [articulos, setArticulos] = useState([]);

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);

  // Editar nota (tickets 28 OCT 2026)
  const [modalEditarNota, setModalEditarNota] = useState(false);
  const toggleEditarNota = () => setModalEditarNota(!modalEditarNota);
  const [notaEditar, setNotaEditar] = useState({});
  const [lineasEditar, setLineasEditar] = useState([]);
  const [obsEditar, setObsEditar] = useState("");
  const [paqEditar, setPaqEditar] = useState("");
  const [guardandoNota, setGuardandoNota] = useState(false);

  // Imagenes y archivos de la nota
  const [modalArchivosNota, setModalArchivosNota] = useState(false);
  const toggleArchivosNota = () => setModalArchivosNota(!modalArchivosNota);
  const [notaArchivos, setNotaArchivos] = useState({});
  const [archivosNota, setArchivosNota] = useState([]);
  const [archivosNuevos, setArchivosNuevos] = useState([]);
  const [seleccionQuitar, setSeleccionQuitar] = useState([]);

  // Entregas parciales y acuses (junta 28 OCT 2026)
  const [modalEntregas, setModalEntregas] = useState(false);
  const toggleEntregas = () => setModalEntregas(!modalEntregas);
  const [notaEntregas, setNotaEntregas] = useState({});
  const [infoEntregas, setInfoEntregas] = useState(null);
  const [capturaEntrega, setCapturaEntrega] = useState({});
  const [datosEntrega, setDatosEntrega] = useState({ fecha: "", recibio: "", observaciones: "" });
  const [acusesNuevos, setAcusesNuevos] = useState([]);
  const [guardandoEntrega, setGuardandoEntrega] = useState(false);

  const [rollos, setRollos] = useState([]);

  //--- Pagination
  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  // const classes = useStyles();
  const [inputFields, setInputFields] = useState([
    {
      id: uuidv4(),
      _id: "",
      articulo: "",
      cliente: "",
    },
  ]);

  const ITEMS_PER_PAGE = 50;

  const Toast = Swal.mixin({
      toast: true,
      position: "center",
      showConfirmButton: false,
      // timer: 5000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.addEventListener("mouseenter", Swal.stopTimer);
        toast.addEventListener("mouseleave", Swal.resumeTimer);
      },
    });
    if (cargando) {
      Toast.fire({
        html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
      });
    }
  useEffect(() => {
    axios
      .get(URL_CLIENTES, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allClientes = response.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });
      axios
        .get(URL_PAQUETERIAS, {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((response) => {
          let allPaqueterias = response.data;
          setPaqueterias(allPaqueterias);
        })
        .catch((err) => {
          console.log(err);
        });
  }, []);

  useMemo(()=>{
    axios
    .get(`${URL_SURTIDOS}Fechas/${selectedFechaInicio}/${selectedFechaFin}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allSurtidos = response.data;
        // Array para pagination
        let arrayTabla = allSurtidos
          .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
          .map((a) => {
            return {
              _id: a._id,
              fecha: a.fecha,
              // Con ?. un dato faltante (p.ej. notas creadas por el corte de Meli) no tumba la lista
              user: `${a.user?.[0]?.nombre || ""} ${a.user?.[0]?.apellido || ""}`.trim(),
              idUser: a.user?.[0]?._id,
              pedidos: a.pedidos?.[0]?.idPedido,
              idPedido: a.pedidos?.[0]?._id,
              clientes: a.pedidos?.[0]?.clientes?.[0]?.nombre_comercial,
              codigoClientes: a.pedidos?.[0]?.clientes?.[0]?.codigo,
              idClientes: a.pedidos?.[0]?.clientes?.[0]?._id,
              observaciones: a.observaciones,
              numero: a.idSurtido,
              comisionTDC: a.pedidos?.[0]?.comisionTDC,
              comisionFlete: a.pedidos?.[0]?.comisionFlete,
              impuestos: a.pedidos?.[0]?.impuestos,
              subTotal: a.subTotal,
              iva: a.iva,
              total_general: a.total_general,
              idDirEnt: a.pedidos?.[0]?.sucursales,
              alias: a.pedidos?.[0]?.sucursales?.[0]?.alias,
              calle: a.pedidos?.[0]?.sucursales?.[0]?.calle,
              numero_ext: a.pedidos?.[0]?.sucursales?.[0]?.numero_ext,
              numero_int: a.pedidos?.[0]?.sucursales?.[0]?.numero_int,
              pais: a.pedidos?.[0]?.sucursales?.[0]?.pais,
              estado: a.pedidos?.[0]?.sucursales?.[0]?.estado,
              ciudad: a.pedidos?.[0]?.sucursales?.[0]?.ciudad,
              delegacion: a.pedidos?.[0]?.sucursales?.[0]?.delegacion,
              colonia: a.pedidos?.[0]?.sucursales?.[0]?.colonia,
              cp: a.pedidos?.[0]?.sucursales?.[0]?.cp,
              paqueteria: a.paqueterias?.[0]?.name,
              idPaqueteria: a.paqueterias?.[0]?._id,
              RFC: a.pedidos?.[0]?.sucursales?.[0]?.RFC,
              area: a.pedidos?.[0]?.areas?.[0]?.name,
              vendedor: `${a.pedidos?.[0]?.colaboradores?.[0]?.nombre || ""} ${a.pedidos?.[0]?.colaboradores?.[0]?.apellido || ""}`.trim(),
              is_active: a.is_active,
              entregado: a.entregado,
              telefono: a.pedidos?.[0]?.clientes?.[0]?.telefono,
              autorizadoSurtido: a.autorizadoSurtido,
              archivos: a.archivos || [],
              editado: a.editado,
              editadoPor: a.editadoPor,
              saldo: a.saldo,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);
        setSurtidos(allSurtidos);
        setComments(dataFinal);
        setCargando(false);
        Toast.close();
        //
      })
      .catch((err) => {
        console.log(err);
      });
  }, [selectedFechaInicio ,selectedFechaFin])

  const ListaSurtidos = comments.sort((a, b) =>
    a.idSurtido > b.idSurtido ? 1 : -1
  );

  function PDFTabla() {
    const data = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [a.numero, a.fecha, a.clientes, a.paqueteria, a.pedidos, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 15, 30, 30);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Cliente", "Paqueteria", "Pedido", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    doc.save(`Surtidos.pdf`);
  }

  function excel() {
    const dataExcel = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return {
          Numero: a.numero,
          Fecha: a.fecha,
          Cliente: a.clientes,
          Pedido: a.pedidos,
          Surtio: a.user,
        };
      }
    });
    const dataExportExcel = Object.values(dataExcel);
    const dataExcelLimpia = dataExportExcel.filter(function (el) {
      return el != null;
    });

    var option = {};

    option.fileName = "ListadoNotas";

    option.datas = [
      {
        sheetData: dataExcelLimpia,
        sheetName: "ListadoNotas",
        sheetFilter: ["Numero", "Fecha", "Cliente", "Pedido", "Surtio"],
        sheetHeader: ["Numero", "Fecha", "Cliente", "Pedido", "Surtio"],
      },
    ];

    var toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  function enviaMail() {
    const data = ListaSurtidos.map((a) => {
      if (
        (selectedFechaInicio == 0 || selectedFechaInicio <= a.fecha) &&
        (selectedFechaFin == 0 || selectedFechaFin >= a.fecha) &&
        (activo == 0 || activo == a.is_active) &&
        (autorizadoSurtido == 0 || autorizadoSurtido == a.autorizadoSurtido) &&
        (selectedCliente == 0 || selectedCliente == a.idClientes)
      ) {
        return [a.numero, a.fecha, a.clientes, a.pedidos, a.user];
      }
    });
    const dataPDF = Object.values(data);
    const dataPDFLimpia = dataPDF.filter(function (el) {
      return el != null;
    });
    const doc = new jsPDF({compressPdf: true});
    var img = new Image();
    img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
    doc.addImage(img, "png", 150, 5, 33, 10);
    var img2 = new Image();
    img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
    doc.addImage(img2, "png", 150, 15, 30, 30);
    doc.text(`Listado de Notas`, 20, 30);
    doc.text(`${selectedFechaInicio} - ${selectedFechaFin}`, 20, 40);
    doc.autoTable({
      head: [["Numero", "Fecha", "Cliente", "Pedido", "Surtio"]],
      body: dataPDFLimpia,
      startY: 50,
    });
    var att = doc.output("arraybuffer");
    var base64File = encode(att);

    // Envia el Mail
    axios
      .post(
        URL_SEND_MAIL_ATT,
        {
          subject: "Listado de Notas",
          email: mailTo,
          fileName: "ListadoNotas.pdf",
          att: base64File,
          text: `<table border="0" cellpadding="0" cellspacing="0" width="100%">
         <th><img width="${process.env.REACT_APP_TAMANO_LOGO_MAIL}" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}logoInstitucion.png" /></th>
         <tr align="center" style="font-size:30px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>${process.env.REACT_APP_NOMBRE_INSTITUCION}</tr>
         <tbody>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Hola,</tr>
         <tr style="font-size:20px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px;font-weight:bold"><br>Adjunto encontraras el listado de Notas.</tr>
         </tbody>
         <tr style="font-size:16px;font-family:Helvetica,Arial,sans-serif;color:#333333;padding-top:10px"><br>Favor de no responder este correo, para cualquier duda favor de comunicarse al ${process.env.REACT_APP_TELEFONO_INSTITUCION}</tr>
         <tr align="right"><br>Powered by <a href="https://lynqro.com"> <img width="20%" align="center" src="${process.env.REACT_APP_LINK_SISTEMA}Logo-Lynqro-PDF.png" /> </a> </tr>
         </table>`,
        },
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then(() => {
        toggleMail();
        Swal.fire("Good job!", "Enviado con exito", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      })
      .catch((error) => {
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          footer: `${error.response.data}`,
        });
        console.log(error);
      });
  }

  async function PDFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    alias,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes,
    vendedor,
    telefono,
    autorizadoSurtido
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a.inventarios[0]._id,
              articulos:
                a.articulos[0].SKU +
                " " +
                a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.precio,
              precioBruto: a.precioBruto,
              precioOriginal: a.articulos[0].venta,
              cajas: a.cantidad / a.articulos[0].piezasPorCaja,
              cliente: a.articulosPedido[0].cliente,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        // let agrupado = dataFinal.reduce(function (groups, item) {
        //   const val = item["idArticulo"];
        //   groups[val] = groups[val] || {
        //     idArticulo: item.idArticulo,
        //     cantidad: 0,
        //     cajas: 0,
        //   };
        //   groups[val].cantidad += item.cantidad;
        //   groups[val].cajas += item.cajas;
        //   groups[val].articulos = item.articulos;
        //   groups[val].precio = item.precio;
        //   groups[val].precioOriginal = item.precioOriginal;
        //   return groups;
        // }, []);

        // let agrupadoValues = Object.values(agrupado);

        let totalMts = dataFinal.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);

        let TC = dataFinal.map((c) => parseFloat(c.cajas));
        let TTC = TC.reduce((t, total, index) => t + total, 0);

        let totalParcial = 0;

        const data = dataFinal.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return [
            a.articulos,
            new Intl.NumberFormat("en-US").format(a.cajas.toFixed(2)),
            new Intl.NumberFormat("en-US").format(a.cantidad),
            a.cliente,
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.precioOriginal),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.precio),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(a.precioBruto),
            new Intl.NumberFormat("en-US", {
              style: "currency",
              currency: "USD",
              maximumFractionDigits: 2,
              
            }).format(totalParcial),
          ];
        });

        const dataPDF = Object.values(data);
        const dataPDFLimpia = dataPDF.filter(function (el) {
          return el != null;
        });
        const doc = new jsPDF({compressPdf: true});
        var img = new Image();
        img.src = process.env.PUBLIC_URL + "Logo-Lynqro-PDF.png";
        doc.addImage(img, "png", 8, 5, 18, 5);
        var img2 = new Image();
        img2.src = process.env.PUBLIC_URL + "logoInstitucion.png";
        doc.addImage(img2, "png", 10, 11, 15, 15);

        doc.setFontSize(12);
        doc.text(`Fecha:`, 35, 15);
        doc.text(`${fecha}`, 60, 15);
        doc.text(`Nota:`, 35, 20);
        doc.text(`${numero}`, 60, 20);
        doc.text(`Pedido:`, 35, 25);
        doc.text(`${pedidos}`, 60, 25);

        doc.text(`Ejecutivo:`, 90, 15);
        doc.text(`${vendedor}`, 115, 15);
        doc.text(`Almacen:`, 90, 20);
        doc.text(`${area}`, 115, 20);
        doc.text(`Paqueteria:`, 90, 25);
        doc.text(`${paqueteria}`, 115, 25);

        if(autorizadoSurtido == "Si"){
          doc.text(`AUTORIZADO`, 150, 40);
        }

        doc.setFontSize(8);
        doc.text(`Cliente: ${codigoClientes} - ${clientes}`, 10, 32);
        // doc.text(`RFC: ${RFC}`, 150, 32);
        doc.text(`Sucursal: ${alias}`, 10, 37);
        doc.text(
          `Direccion de Envio: ${calle} #${numero_ext} Int. ${numero_int} Telefono: ${telefono}`,
          10,
          42
        );
        // doc.text(
        //   `Edo: ${estado}, Ciudad: ${ciudad}, Del: ${delegacion}, Col: ${colonia}, CP: ${cp} Paqueteria: ${paqueteria}`,
        //   10,
        //   47
        // );

        doc.autoTable({
          head: [["Articulo", "Cajas", "Cantidad", "Cliente", "Precio Original", "Precio", "Precio Bruto", "Total"]],
          body: dataPDFLimpia,
          styles: {
            fontSize: 8,
            // overflow: "linebreak",
            // columnWidth: "wrap",
            // // font: 'arial',
            // overflowColumns: "linebreak",
          },
          margin: { left: 5, right: 5 },
          startY: 50,
          footStyles: {
            fontSize: 9,
            fillColor: [255,255,255],
            textColor: [0,0,0]
          },
          foot: [
            [
              "",
              new Intl.NumberFormat("en-US").format(TTC.toFixed(2)) + " Cajas",
              new Intl.NumberFormat("en-US").format(TM) + " Piezas",
              "",
              "",
              "",
              "Sub Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(subTotal.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "",
              `Comision`,
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(iva.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "",
              "Comision TDC",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(comisionTDC.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "",
              "Comision Flete",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(comisionFlete.toFixed(2)),
            ],
            [
              "",
              "",
              "",
              "",
              "",
              "",
              "Total",
              new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
                maximumFractionDigits: 2,
                
              }).format(total_general.toFixed(2)),
            ],
          ],
          showFoot: "lastPage",
        });

        doc.save(`Nota-${numero}.pdf`);
        //   }
        // });
        // });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  async function excelFOC(
    fecha,
    idClientes,
    clientes,
    observaciones,
    numero,
    idPDFOC,
    user,
    pedidos,
    comisionTDC,
    comisionFlete,
    impuestos,
    subTotal,
    iva,
    total_general,
    alias,
    calle,
    numero_ext,
    numero_int,
    pais,
    estado,
    ciudad,
    delegacion,
    colonia,
    cp,
    RFC,
    paqueteria,
    area,
    codigoClientes
  ) {
    await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
          .map((a) => {
            return {
              id: a.inventarios[0]._id,
              articulos: a.articulos[0].SKU + " " + a.articulos[0].nombre,
              cantidad: a.cantidad,
              idArticulo: a.articulos[0]._id,
              precio: a.articulosPedido[0].precio,
            };
          })
          .filter(function (el) {
            return el != null;
          });
        let dataFinal = Object.values(arrayTabla);
        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].articulos = item.articulos;
          groups[val].precio = item.precio;
          return groups;
        }, []);
        let agrupadoValues = Object.values(agrupado);
        let totalMts = agrupadoValues.map((c) => parseFloat(c.cantidad));
        let TM = totalMts.reduce((t, total, index) => t + total, 0);
        let totalParcial = 0;
        const data = agrupadoValues.map((a) => {
          totalParcial = a.cantidad * a.precio;
          return {
            Articulos: a.articulos,
            Cantidad: a.cantidad,
            Precio: a.precio,
            TotalParcial: totalParcial,
          };
        });
        const dataExportExcel = Object.values(data);
        const dataExcelLimpia = dataExportExcel.filter(function (el) {
          return el != null;
        });

        const data2 = [
          {
            Cliente: codigoClientes + " " + clientes,
            Nota: numero,
            RFC: RFC,
            Direccion:
              calle +
              " " +
              numero_int +
              " " +
              numero_ext +
              " " +
              estado +
              " " +
              ciudad +
              " " +
              delegacion +
              " " +
              colonia +
              " " +
              cp,
            Impuestos: impuestos,
            IVA: iva,
            TotalGeneral: total_general,
            ComisionTDC: comisionTDC,
            ComisionFlete: comisionFlete,
            Fecha: fecha,
            Observaciones: observaciones,
          },
        ];

        var option = {};
        option.fileName = `Nota ${numero}`;
        option.datas = [
          {
            sheetData: data2,
            sheetName: `Datos Generales`,
            sheetFilter: [
              "Nota",
              "Fecha",
              "Cliente",
              "RFC",
              "Direccion",
              "Impuestos",
              "IVA",
              "TotalGeneral",
              "ComisionTDC",
              "ComisionFlete",
              "Observaciones",
            ],
            sheetHeader: [
              "Nota",
              "Fecha",
              "Cliente",
              "RFC",
              "Direccion",
              "Impuestos",
              "IVA",
              "TotalGeneral",
              "ComisionTDC",
              "ComisionFlete",
              "Observaciones",
            ],
          },
          {
            sheetData: dataExcelLimpia,
            sheetName: `Articulos`,
            sheetFilter: ["Articulos", "Cantidad", "Precio", "TotalParcial"],
            sheetHeader: ["Articulos", "Cantidad", "Precio", "TotalParcial"],
          },
        ];

        var toExcel = new ExportJsonExcel(option);
        toExcel.saveExcel();
      })
      .catch((err) => {
        console.log(err);
      });
  }


  const authHeaders = () => ({
    headers: { Authorization: `Bearer: ${localStorage.getItem("app_token")}` },
  });
  const pesos = (n) =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 2 }).format(n || 0);

  function abreEditarNota(nota) {
    setNotaEditar(nota);
    setObsEditar(nota.observaciones || "");
    setPaqEditar(nota.idPaqueteria || "");
    setLineasEditar([]);
    setModalEditarNota(true);
    axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${nota._id}`, authHeaders())
      .then((res) =>
        setLineasEditar(
          res.data.map((l) => {
            const art = l.inventarios?.[0]?.articulos?.[0] || l.articulos?.[0] || {};
            return {
              _id: l._id,
              articulo: `${art.SKU || ""} ${art.nombre || ""}`.trim(),
              ubicacion: l.inventarios?.[0]?.ubicacion || "",
              existencia: Number(l.inventarios?.[0]?.cantidad) || 0,
              entregado: Number(l.entregadoCantidad) || 0,
              cantidadOriginal: Number(l.cantidad) || 0,
              precioOriginal: Number(l.precio) || 0,
              cantidad: Number(l.cantidad) || 0,
              precio: Number(l.precio) || 0,
              motivo: "inventario",
            };
          })
        )
      )
      .catch((error) => {
        console.log(error);
        setModalEditarNota(false);
        Swal.fire({ icon: "error", title: "No se pudieron cargar los renglones" });
      });
  }

  function cambiaLinea(id, campo, valor) {
    setLineasEditar(lineasEditar.map((l) => (l._id === id ? { ...l, [campo]: valor } : l)));
  }

  const subTotalEditado = lineasEditar.reduce(
    (t, l) => t + (parseFloat(l.cantidad) || 0) * (parseFloat(l.precio) || 0),
    0
  );

  function guardaNota() {
    const lineas = lineasEditar
      .filter(
        (l) =>
          parseFloat(l.cantidad) !== l.cantidadOriginal || parseFloat(l.precio) !== l.precioOriginal
      )
      .map((l) => ({ _id: l._id, cantidad: parseFloat(l.cantidad) || 0, precio: parseFloat(l.precio) || 0, motivo: l.motivo }));
    const cambiaObs = obsEditar !== (notaEditar.observaciones || "");
    const cambiaPaq = paqEditar && paqEditar !== (notaEditar.idPaqueteria || "");
    if (!lineas.length && !cambiaObs && !cambiaPaq) {
      Swal.fire({ icon: "info", title: "No hay cambios" });
      return;
    }
    setGuardandoNota(true);
    axios
      .patch(
        `${URL_SURTIDOS}EditarVenta/${notaEditar._id}`,
        {
          lineas,
          ...(cambiaObs ? { observaciones: obsEditar } : {}),
          ...(cambiaPaq ? { paqueterias: paqEditar } : {}),
        },
        authHeaders()
      )
      .then((res) => {
        const n = res.data.surtido;
        axios.post(
          URL_LOGS,
          { tipo: "Editar Nota", detalle: `${notaEditar.numero} ${res.data.deltaTotal}`, user: user.id },
          authHeaders()
        );
        setComments(
          comments.map((c) =>
            c._id === notaEditar._id
              ? {
                  ...c,
                  subTotal: n.subTotal,
                  iva: n.iva,
                  total_general: n.total_general,
                  saldo: n.saldo,
                  observaciones: n.observaciones,
                  idPaqueteria: paqEditar || c.idPaqueteria,
                  paqueteria: (paqueterias.find((p) => p._id === paqEditar) || {}).name || c.paqueteria,
                  editado: "Si",
                  editadoPor: n.editadoPor,
                }
              : c
          )
        );
        setModalEditarNota(false);
        Swal.fire({
          icon: "success",
          title: "Nota actualizada",
          text: res.data.deltaTotal
            ? `El total cambio ${res.data.deltaTotal > 0 ? "+" : ""}${pesos(res.data.deltaTotal)} y se ajusto el saldo del cliente.`
            : "",
        });
      })
      .catch((error) =>
        Swal.fire({
          icon: "error",
          title: "No se pudo editar",
          text: error?.response?.data?.message || "Algo salio mal",
        })
      )
      .finally(() => setGuardandoNota(false));
  }

  function abreArchivosNota(nota) {
    setNotaArchivos(nota);
    setArchivosNota(nota.archivos || []);
    setArchivosNuevos([]);
    setSeleccionQuitar([]);
    setModalArchivosNota(true);
  }

  function aplicaArchivosNota(lista) {
    setArchivosNota(lista);
    setComments(comments.map((c) => (c._id === notaArchivos._id ? { ...c, archivos: lista } : c)));
  }

  async function subeArchivosNota() {
    if (!archivosNuevos.length) {
      Swal.fire({ icon: "error", title: "Elige primero las imagenes o archivos" });
      return;
    }
    const resultado = await subirEnSerie(
      archivosNuevos,
      (archivo, nombre) => {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("nombre", nombre);
        return axios.post(`${URL_SURTIDOS}Archivo/${notaArchivos._id}`, formData, authHeaders());
      },
      `Subiendo a la nota ${notaArchivos.numero}`
    );
    const datos = resultado.ultimaRespuesta?.data;
    if (datos) aplicaArchivosNota(datos.archivos || []);
    setArchivosNuevos(archivosNuevos.filter((f) => resultado.fallidos.some((x) => x.nombre === nombreDe(f))));
    avisaResultado(resultado, "Quedaron en los archivos de la nota.");
  }

  function quitaArchivosNota() {
    if (!seleccionQuitar.length) return;
    Swal.fire({
      title: seleccionQuitar.length === 1 ? "¿Quitar el archivo?" : `¿Quitar ${seleccionQuitar.length} archivos?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si, quitar",
      cancelButtonText: "Cancelar",
    }).then((r) => {
      if (!r.isConfirmed) return;
      axios
        .patch(`${URL_SURTIDOS}ArchivoQuitar/${notaArchivos._id}`, { ids: seleccionQuitar }, authHeaders())
        .then((res) => {
          aplicaArchivosNota(res.data.archivos || []);
          setSeleccionQuitar([]);
        })
        .catch((error) =>
          Swal.fire({ icon: "error", title: error?.response?.data?.message || "No se pudieron quitar" })
        );
    });
  }

  function abreEntregas(nota) {
    setNotaEntregas(nota);
    setInfoEntregas(null);
    setCapturaEntrega({});
    setDatosEntrega({ fecha: moment().format("YYYY-MM-DD"), recibio: "", observaciones: "" });
    setAcusesNuevos([]);
    setModalEntregas(true);
    cargaEntregas(nota._id);
  }

  function cargaEntregas(id) {
    axios
      .get(`${URL_SURTIDOS}Entregas/${id}`, authHeaders())
      .then((r) => setInfoEntregas(r.data))
      .catch((error) => {
        console.log(error);
        setModalEntregas(false);
        Swal.fire({ icon: "error", title: "No se pudieron leer las entregas" });
      });
  }

  function capturaRenglon(id, campo, valor) {
    setCapturaEntrega({ ...capturaEntrega, [id]: { ...(capturaEntrega[id] || {}), [campo]: valor } });
  }

  // Todo lo pendiente del renglon como entregado
  function entregaTodo() {
    const todo = {};
    (infoEntregas?.renglones || []).forEach((r) => {
      if (r.porEntregar > 0) todo[r._id] = { entregado: r.porEntregar };
    });
    setCapturaEntrega(todo);
  }

  async function subeAcuses(idEntrega, archivos) {
    const resultado = await subirEnSerie(
      archivos,
      (archivo, nombre) => {
        const formData = new FormData();
        formData.append("file", archivo);
        formData.append("nombre", nombre);
        return axios.post(`${URL_SURTIDOS}Acuse/${notaEntregas._id}/${idEntrega}`, formData, authHeaders());
      },
      `Subiendo acuse de la nota ${notaEntregas.numero}`
    );
    return resultado;
  }

  async function guardaEntrega() {
    const renglones = Object.entries(capturaEntrega)
      .map(([_id, v]) => ({
        _id,
        entregado: parseFloat(v.entregado) || 0,
        danado: parseFloat(v.danado) || 0,
        faltante: parseFloat(v.faltante) || 0,
      }))
      .filter((r) => r.entregado || r.danado || r.faltante);
    if (!renglones.length) {
      Swal.fire({ icon: "info", title: "Captura cuanto se entrego" });
      return;
    }
    const conAjuste = renglones.some((r) => r.danado || r.faltante);
    if (conAjuste) {
      const ok = await Swal.fire({
        title: "¿Registrar danados/faltantes?",
        text: "Se descuentan de la nota (y del saldo del cliente) y regresan a pendiente del pedido. Lo danado pasa a Mermas.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Si, registrar",
        cancelButtonText: "Cancelar",
      });
      if (!ok.isConfirmed) return;
    }
    setGuardandoEntrega(true);
    try {
      const r = await axios.post(
        `${URL_SURTIDOS}Entrega/${notaEntregas._id}`,
        { ...datosEntrega, renglones },
        authHeaders()
      );
      axios.post(
        URL_LOGS,
        { tipo: "Entrega Nota", detalle: `${notaEntregas.numero} ${renglones.map((x) => x.entregado).join(",")}`, user: user.id },
        authHeaders()
      );
      if (acusesNuevos.length) {
        const res = await subeAcuses(r.data.entrega._id, acusesNuevos);
        if (res.fallidos.length) avisaResultado(res, "");
      }
      setComments(
        comments.map((c) =>
          c._id === notaEntregas._id
            ? { ...c, subTotal: r.data.surtido.subTotal, iva: r.data.surtido.iva, total_general: r.data.surtido.total_general, saldo: r.data.surtido.saldo }
            : c
        )
      );
      setCapturaEntrega({});
      setAcusesNuevos([]);
      cargaEntregas(notaEntregas._id);
      Swal.fire({
        icon: "success",
        title: r.data.completa ? "Nota entregada completa" : "Entrega parcial registrada",
        text: acusesNuevos.length ? "Acuse cargado: se aviso a Cobranza." : "Falta cargar el acuse firmado.",
      });
    } catch (error) {
      Swal.fire({ icon: "error", title: "No se pudo registrar", text: error?.response?.data?.message || "Algo salio mal" });
    } finally {
      setGuardandoEntrega(false);
    }
  }

  // Acuse para una entrega ya registrada
  function agregaAcuse(idEntrega) {
    const input = document.createElement("input");
    input.type = "file";
    input.multiple = true;
    input.accept = "image/*,application/pdf";
    input.onchange = async () => {
      const archivos = Array.from(input.files || []);
      if (!archivos.length) return;
      const res = await subeAcuses(idEntrega, archivos);
      avisaResultado(res, "Acuse guardado: se aviso a Cobranza.");
      cargaEntregas(notaEntregas._id);
    };
    input.click();
  }

  const esImagen = (f) => /\.(jpe?g|png|gif|webp|heic|bmp)$/i.test(f.url || "") || /\/image\/upload\//.test(f.url || "");

  const headers = [
    { name: "Numero", field: "numero", sortable: true },
    { name: "Fecha", field: "fecha", sortable: true },
    { name: "Cliente", field: "clientes", sortable: true },
    { name: "Paqueteria", field: "paqueteria", sortable: true },
    { name: "Almacen", field: "area", sortable: true },
    { name: "Vendedor", field: "vendedor", sortable: true },
    { name: "Pedido", field: "pedidos", sortable: true },
    { name: "Surtió", field: "user", sortable: true },
    { name: "Detalles", field: "acciones", sortable: false },
  ];

  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) =>
          comment.user.toLowerCase().includes(search.toLowerCase()) ||
          comment.clientes.toLowerCase().includes(search.toLowerCase()) ||
          comment.area.toLowerCase().includes(search.toLowerCase()) ||
          comment.vendedor.toLowerCase().includes(search.toLowerCase()) ||
          comment.paqueteria.toLowerCase().includes(search.toLowerCase()) ||
          comment.pedidos.toString().includes(search) ||
          comment.numero.toString().includes(search)
      );
    }
    if (selectedCliente) {
      computedComments = computedComments.filter((e) =>
        e.idClientes.includes(selectedCliente)
      );
    }
    if (selectedUser) {
      computedComments = computedComments.filter((e) =>
        e.idUser.includes(selectedUser)
      );
    }

    if (selectedFechaInicio) {
      computedComments = computedComments.filter(
        (e) => e.fecha >= selectedFechaInicio
      );
    }

    if (selectedFechaFin) {
      computedComments = computedComments.filter(
        (e) => e.fecha <= selectedFechaFin
      );
    }
    if (autorizadoSurtido) {
      computedComments = computedComments.filter((e) =>
        e.autorizadoSurtido.includes(autorizadoSurtido)
      );
    }

    setTotalItems(computedComments.length);

    //Sorting comments
    if (
      sorting.field &&
      sorting.field != "pedidos" &&
      sorting.field != "numero"
    ) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    if (
      sorting.field &&
      sorting.order === "asc" &&
      (sorting.field == "pedidos" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) > parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    if (
      sorting.field &&
      sorting.order === "desc" &&
      (sorting.field == "pedidos" || sorting.field == "numero")
    ) {
      computedComments = computedComments.sort((a, b) =>
        parseFloat(a[sorting.field]) < parseFloat(b[sorting.field]) ? 1 : -1
      );
    }

    //Current Page slice
    return computedComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [
    comments,
    currentPage,
    search,
    sorting,
    selectedCliente,
    selectedUser,
    selectedFechaInicio,
    selectedFechaFin,
    autorizadoSurtido
  ]);

  function autorizar(id) {
    const URL_AUTORIZADO = `${URL_SURTIDOS}/${id}`;
    Swal.fire({
      title: "Estas seguro?",
      text: "Se guardara!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .patch(
            URL_AUTORIZADO,
            {
              autorizadoSurtido: "Si",
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            Swal.fire("Good job!", "Autorizado", "success");
            setTimeout(() => {
              window.location.reload();
            }, 1000);
          }).catch((error) => {
            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
              footer: `${error.response.data}`,
            });
            console.log(error);
          })
      }
    });
  }

  function QRGen(id, cliente, numero, paqueteria) {
    axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${id}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then(async (response) => {
        let allRollos = response.data;
        setRollos(allRollos);
  
        const doc = new jsPDF("landscape", "mm", [55, 40]);
  
        for (const a of allRollos) {
          const codigo = a._id;
  
          // Generar código QR como base64
          const base64 = await qrcode.toDataURL(codigo);
  
          // Generar tantas hojas como indique 'cantidad'
          for (let i = 0; i < a.cantidad; i++) {
            const img3 = new Image();
            img3.src = base64;
  
            // Agregar el código QR y detalles al PDF
            doc.addImage(img3, "png", 13, 14, 25, 25);
            doc.setFontSize(8);
            doc.text(`Cliente: ${cliente}`, 3, 7.5);
            doc.text(`Articulo: ${a.articulos[0].SKU}`, 3, 11);
            doc.text(`Paqueteria: ${paqueteria}`, 3, 14.5);
  
            // Agregar una nueva página para la siguiente
            doc.addPage();
          }
        }
  
        // Guardar el PDF
        doc.save(`QR.pdf`);
      })
      .catch((err) => {
        console.log(err);
      });
  }
  

  function entregar(){
    setInputFields([
      {
        id: uuidv4(),
        _id: "",
        articulo: "",
        cliente: "",
      },
    ]);

      toggleEntregar();
  
  }
  function jalaPaqueteria(id) {
    // Set the selected paqueteria
    setSelectedPaqueteria(id);
    toggleProgreso()
    axios
        .get(`${URL_ARTICULOS_SURTIDOS}entregarPaqueteria/${id}`, {
            headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
        })
        .then((response) => {
            let allArticulos = response.data;
            setArticulos(allArticulos);

            // Obtener los _id de cada paquetería
            let result = allArticulos.map(({ _id }) => _id);
            setIdsArticulo(result); // Guardar los ids obtenidos
            setModalProgreso(false)
        })
        .catch((err) => {
            console.log(err);
        });
}

function BuscaArticulo(id, event) {
  if (event.target.value.length >= 24) {
    if (idsArticulo.includes(event.target.value)) {
      // if (
      //   inputFields.filter((e) => e._id == event.target.value)
      //     .length > 0
      // ) {
      //   Swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "El articulo ya fue escaneado!",
      //     showConfirmButton: false,
      //   });
      //   const newInputFields = inputFields.map((i) => {
      //     if (id === i.id) {
      //       i._id = "";
      //     }
      //     return i;
      //   });
      //   setInputFields(newInputFields);
      // } else {
        articulos.map((a) => {
          if (a._id == event.target.value) {
            let _id = a._id;
            let articulo = a.articulos[0].SKU + " " + a.articulos[0].nombre;
            let cliente = a.clientes[0].nombre_comercial;
            handleChangeInputSurtido(
              id,
              _id,
              articulo,
              cliente
            );
          }
        });
      // }
    } else {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El surtido no pertenece a la paqueteria!",
        showConfirmButton: false,
      });
      const newInputFields = inputFields.map((i) => {
        if (id === i.id) {
          i._id = "";
        }
        return i;
      });
      setInputFields(newInputFields);
    }
  } else {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i._id = event.target.value;
      }
      return i;
    });
    setInputFields(newInputFields);
  }
}

const handleChangeInputSurtido = (
  id,
  _id,
  articulo,
  cliente
) => {
  const newInputFields = inputFields.map((i) => {
    if (id === i.id) {
      i._id = _id;
      i.articulo = articulo;
      i.cliente = cliente;
    }
    return i;
  });
  setInputFields(newInputFields);
  handleAddFields();
};

const handleAddFields = () => {
  setInputFields([
    ...inputFields,
    {
      id: uuidv4(),
      _id: "",
      articulo: "",
      cliente: "",
    },
  ]);
};

const saveEntregar = async () => {
  // event.preventDefault();
  // setValidaBoton(false);
  // toggleProgreso();
  let totalPedido = inputFields.length

  try {
        inputFields.map((a) => {
          if(a._id != ""){
          axios.patch(
            `${URL_ARTICULOS_SURTIDOS}Entrega/${a._id}`,
            {
              entregadoCantidad: 1
            },
            {
              headers: {
                Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
              },
            }
          )
          .then(()=>{
            totalPedido = totalPedido -1
            if(totalPedido == 0 ){
                  Swal.fire("Good job!", "Creado con exito", `success`);
                  setTimeout(() => {
                    window.location.reload();
                  }, 1000);
            }
          })
        }else{ 
          totalPedido = totalPedido -1
          if(totalPedido == 0 ){
                Swal.fire("Good job!", "Creado con exito", `success`);
                setTimeout(() => {
                  window.location.reload();
                }, 1000);
          }
        }
        });
  } catch (error) {
    Swal.fire({
      icon: "error",
      title: "Oops...",
      text: "Something went wrong!",
      footer: `${error.response.data}`,
    });
    console.log(error);
  }
};

  return (
    <>
      <Header />
      <br />
      <br />
      {user.menu_surtidos ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/MenuVentas"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
              <Button
                title="Entregar guias por paqueteria (escaneo de etiquetas)"
                size="sm"
                className="btn"
                color="info"
                onClick={(e) => entregar()}

              >
                 Entregar <i class="far fa-paper-plane"></i>

              
              </Button>
            </Col>
            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  title="Descargar el listado en PDF"
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={PDFTabla}
                >
                  PDF <i class="far fa-file-pdf"></i>
                </Button>
                {/* <Button
                  size="sm"
                  className="btn"
                  color="danger"
                  onClick={
                    e=>{
                      axios
                      .get(`${URL_ARTICULOS_SURTIDOS}Desarrollo`, {
                        headers: {
                          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
                        },
                      })
                      .then((response) => {
                        alert(response)
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                    }
                  }
                >
                  Desarrollo <i class="far fa-file-pdf"></i>
                </Button> */}
                <Button
                  title="Enviar el listado por correo"
                  size="sm"
                  className="btn"
                  onClick={toggleMail}
                  color="info"
                >
                  eMail <i class="fas fa-at"></i>
                </Button>
                <Button
                  title="Descargar el listado en Excel"
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                >
                  Excel <i class="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>
          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Listado de Notas</h4>
            </ModalHeader>
            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button size="sm" color="success" onClick={enviaMail}>
                Enviar
              </Button>
            </ModalFooter>
          </Modal>
          <h3 align="center">Notas</h3>
          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>
            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>
          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                }}
              />
            </Col>
            <Col md={2}>
              <Label>Clientes</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedCliente}
                onChange={(e) => {
                  setSelectedCliente(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {clientes
                  .sort((a, b) =>
                    a.nombre_comercial > b.nombre_comercial ? 1 : -1
                  )
                  .map((a) => {
                    return <option value={a._id}>{a.nombre_comercial}</option>;
                  })}
              </Input>
            </Col>
            <Col md={2}>
                  <Label>Autorizado</Label>
                  <Input
                    bsSize="sm"
                    type="select"
                    value={autorizadoSurtido}
                    required
                    onChange={(e) => {
                      setAutorizadoSurtido(e.target.value);
                      setCurrentPage(1);
                    }}
                  >
                    <option value="">Selecciona</option>
                    <option value="Si">Si</option>
                    <option value="No">No</option>
                  </Input>
                </Col>
          </Row>
          <br />
          <Table size="sm" striped borderless className="table-responsive-xl">
            <TableHeader
              headers={headers}
              onSorting={(field, order) => setSorting({ field, order })}
            />
            <tbody>
              {commentsData.map((a) => {
                if (a.is_active == "No"){
                  return (
                    <tr style={{ backgroundColor: "#ed8c8c" }}>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.paqueteria}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.pedidos}</td>
                      <td>{a.user}</td>
                        <td>CANCELADA
                          <Button
                            title="PDF de la nota"
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.alias,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.pais,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.RFC,
                                  a.paqueteria,
                                  a.area,
                                  a.codigoClientes,
                                  a.vendedor,
                                  a.telefono
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button></td>
                    </tr>
                  );
                }else{
                  return (
                    <tr>
                      <td>{a.numero}</td>
                      <td>{a.fecha}</td>
                      <td>{a.clientes}</td>
                      <td>{a.paqueteria}</td>
                      <td>{a.area}</td>
                      <td>{a.vendedor}</td>
                      <td>{a.pedidos}</td>
                      <td>{a.user}</td>
                        <>
                          <td>
                          <Button
                            title="Etiquetas QR de la nota"
                        size="sm"
                        className="btn"
                        color="success"
                        onClick={(e) =>
                          QRGen(
                            a._id,
                            a.clientes,
                            a.numero,
                            a.paqueteria
                          )
                        }
                      >
                        <i class="fas fa-qrcode"></i>
                      </Button>
                            <Button
                              title="PDF de la nota"
                              size="sm"
                              className="btn"
                              color="danger"
                              onClick={(e) =>
                                PDFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.alias,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.pais,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.RFC,
                                  a.paqueteria,
                                  a.area,
                                  a.codigoClientes,
                                  a.vendedor,
                                  a.telefono,
                                  a.autorizadoSurtido
                                )
                              }
                            >
                              <i class="far fa-file-pdf"></i>
                            </Button>
                            <Button
                              title="Excel de la nota"
                              size="sm"
                              className="btn"
                              color="primary"
                              onClick={(e) =>
                                excelFOC(
                                  a.fecha,
                                  a.idClientes,
                                  a.clientes,
                                  a.observaciones,
                                  a.numero,
                                  a._id,
                                  a.user,
                                  a.pedidos,
                                  a.comisionTDC,
                                  a.comisionFlete,
                                  a.impuestos,
                                  a.subTotal,
                                  a.iva,
                                  a.total_general,
                                  a.alias,
                                  a.calle,
                                  a.numero_ext,
                                  a.numero_int,
                                  a.pais,
                                  a.estado,
                                  a.ciudad,
                                  a.delegacion,
                                  a.colonia,
                                  a.cp,
                                  a.RFC,
                                  a.paqueteria,
                                  a.area,
                                  a.codigoClientes
                                )
                              }
                            >
                              <i class="far fa-file-excel"></i>
                            </Button>
                            {user.surtidos_editar ? (
                              <Button
                                size="sm"
                                className="btn"
                                color="info"
                                title={
                                  a.editado == "Si"
                                    ? `Editar nota (ya editada${a.editadoPor ? " por " + a.editadoPor : ""})`
                                    : "Editar nota"
                                }
                                onClick={() => abreEditarNota(a)}
                              >
                                <i class="far fa-edit"></i>
                              </Button>
                            ) : undefined}
                            <Button
                              size="sm"
                              className="btn"
                              color={a.entregado == "Si" ? "success" : "warning"}
                              title={a.entregado == "Si" ? "Entregas y acuses (entregada)" : "Entregas parciales y acuses"}
                              onClick={() => abreEntregas(a)}
                            >
                              <i class="fas fa-truck-loading"></i>
                            </Button>
                            <Button
                              size="sm"
                              className="btn"
                              color="secondary"
                              title="Imagenes y archivos de la nota"
                              onClick={() => abreArchivosNota(a)}
                            >
                              <i class="fas fa-paperclip"></i>
                              {a.archivos && a.archivos.length ? ` ${a.archivos.length}` : ""}
                            </Button>
                            {user.ventas_autorizar && a.autorizadoSurtido == "No" ? (
                                    <span>
                                      <Button
                                        title="Autorizar la nota"
                                        color="primary"
                                        // id="Baja"
                                        onClick={(e) =>
                                          autorizar(a._id)
                                        }
                                        size="sm"
                                      >
                                        <i class="fas fa-thumbs-up"></i>
                                      </Button>
                                    </span>
                                  ) : undefined}
                          </td>
                        </>
                    </tr>
                  );
                }

              })}
            </tbody>
          </Table>
          <div className="col-md-6">
            <Pagination
              total={totalItems}
              itemsPerPage={ITEMS_PER_PAGE}
              currentPage={currentPage}
              onPageChange={(page) => setCurrentPage(page)}
            />
          </div>
        </div>
      ) : undefined}
      <br />

      <Modal size="xl" isOpen={modalEditarNota} toggle={toggleEditarNota}>
        <ModalHeader toggle={toggleEditarNota}>
          <h4>Editar nota {notaEditar.numero}</h4>
          <small style={{ color: "#64748b" }}>
            {notaEditar.clientes} · Pedido {notaEditar.pedidos} · Total actual {pesos(notaEditar.total_general)}
          </small>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={8}>
              <Label>Observaciones</Label>
              <Input type="text" value={obsEditar} onChange={(e) => setObsEditar(e.target.value)} />
            </Col>
            <Col md={4}>
              <Label>Paqueteria</Label>
              <Input type="select" value={paqEditar} onChange={(e) => setPaqEditar(e.target.value)}>
                <option value="">Selecciona</option>
                {paqueterias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((p) => (
                    <option value={p._id}>{p.name}</option>
                  ))}
              </Input>
            </Col>
          </Row>
          <br />
          {!lineasEditar.length ? (
            <p>Cargando renglones...</p>
          ) : (
            <Table size="sm" borderless striped>
              <thead>
                <tr>
                  <th>Articulo</th>
                  <th>Ubicacion</th>
                  <th style={{ textAlign: "right" }}>Original</th>
                  <th style={{ minWidth: "110px" }}>Cantidad</th>
                  <th style={{ minWidth: "120px" }}>Precio</th>
                  <th style={{ textAlign: "right" }}>Importe</th>
                </tr>
              </thead>
              <tbody>
                {lineasEditar.map((l) => {
                  const cambio =
                    parseFloat(l.cantidad) !== l.cantidadOriginal || parseFloat(l.precio) !== l.precioOriginal;
                  return (
                    <tr key={l._id} style={cambio ? { backgroundColor: "#fef9c3" } : undefined}>
                      <td>{l.articulo}</td>
                      <td>
                        {l.ubicacion}
                        <br />
                        <small style={{ color: "#64748b" }}>Hay {l.existencia}</small>
                      </td>
                      <td align="right">
                        {l.cantidadOriginal} × {pesos(l.precioOriginal)}
                        {l.entregado ? (
                          <>
                            <br />
                            <small style={{ color: "#64748b" }}>Entregado {l.entregado}</small>
                          </>
                        ) : null}
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min={l.entregado}
                          step="any"
                          value={l.cantidad}
                          onChange={(e) => cambiaLinea(l._id, "cantidad", e.target.value)}
                        />
                        {/* Al bajar cantidad: a donde va lo que se quita */}
                        {parseFloat(l.cantidad) < l.cantidadOriginal ? (
                          <Input
                            bsSize="sm"
                            type="select"
                            value={l.motivo}
                            title="Que pasa con las piezas que se quitan (regresan a pendiente del pedido)"
                            onChange={(e) => cambiaLinea(l._id, "motivo", e.target.value)}
                          >
                            <option value="inventario">Regresa a su ubicacion</option>
                            <option value="danado">Danado (a Mermas)</option>
                            <option value="faltante">Faltante (no regresa)</option>
                          </Input>
                        ) : null}
                      </td>
                      <td>
                        <Input
                          bsSize="sm"
                          type="number"
                          min="0"
                          step="any"
                          value={l.precio}
                          onChange={(e) => cambiaLinea(l._id, "precio", e.target.value)}
                        />
                      </td>
                      <td align="right">{pesos((parseFloat(l.cantidad) || 0) * (parseFloat(l.precio) || 0))}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
          <p style={{ textAlign: "right", fontSize: "0.9rem" }}>
            Subtotal actual {pesos(notaEditar.subTotal)} → <b>nuevo {pesos(subTotalEditado)}</b>
            <br />
            <small style={{ color: "#64748b" }}>
              Al subir una cantidad se descuenta de la misma ubicacion. Al bajarla, la diferencia queda pendiente en el
              pedido y las piezas regresan a su ubicacion, a Mermas (danado) o no regresan (faltante). El saldo del
              cliente se ajusta por la diferencia.
            </small>
          </p>
        </ModalBody>
        <ModalFooter>
          <Button color="success" disabled={guardandoNota || !lineasEditar.length} onClick={guardaNota}>
            {guardandoNota ? "Guardando..." : "Guardar cambios"}
          </Button>
          <Button color="secondary" onClick={toggleEditarNota}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xl" isOpen={modalEntregas} toggle={toggleEntregas} style={{ maxWidth: "min(1280px, 96vw)" }}>
        <ModalHeader toggle={toggleEntregas}>
          <h4>Entregas y acuses · Nota {notaEntregas.numero}</h4>
          <small style={{ color: "#64748b" }}>
            {notaEntregas.clientes} · Pedido {notaEntregas.pedidos}
            {infoEntregas && infoEntregas.acuse === "Si" ? ` · Acuse desde ${infoEntregas.fechaAcuse}` : " · Sin acuse"}
          </small>
        </ModalHeader>
        <ModalBody>
          {!infoEntregas ? (
            <p>Cargando...</p>
          ) : (
            <>
              {(() => {
                // Las columnas de captura solo salen si queda algo por entregar
                const captura = user.entregas_registrar && infoEntregas.renglones.some((r) => r.porEntregar > 0);
                const num = { textAlign: "right", whiteSpace: "nowrap" };
                return (
                  // La tabla se desplaza dentro del modal en pantallas angostas (antes se salia del modal)
                  <div style={{ overflowX: "auto", marginBottom: "12px" }}>
                    <Table size="sm" striped borderless style={{ width: "100%", marginBottom: 0 }}>
                      <thead>
                        <tr>
                          <th style={{ minWidth: "200px" }}>Articulo</th>
                          <th style={num}>Pedido</th>
                          <th style={num}>Surtido</th>
                          <th style={num}>Entregado</th>
                          <th style={num}>Dan. / Falt.</th>
                          <th style={num}>Por entregar</th>
                          {captura ? (
                            <>
                              <th style={{ ...num, width: "80px" }}>Entrega hoy</th>
                              <th style={{ ...num, width: "80px" }}>Danado</th>
                              <th style={{ ...num, width: "80px" }}>Faltante</th>
                            </>
                          ) : null}
                        </tr>
                      </thead>
                      <tbody>
                        {infoEntregas.renglones.map((r) => (
                          <tr key={r._id}>
                            <td>
                              <b>{r.SKU}</b>
                              <div style={{ fontSize: "0.8rem", color: "#475569", lineHeight: 1.3 }}>{r.nombre}</div>
                              {r.pendientePedido ? (
                                <small style={{ color: "#b45309" }}>Pendiente en el pedido: {r.pendientePedido}</small>
                              ) : null}
                            </td>
                            <td style={num}>{r.pedido}</td>
                            <td style={num}>{r.surtido}</td>
                            <td style={{ ...num, color: "#16a34a", fontWeight: 600 }}>{r.entregado}</td>
                            <td style={{ ...num, color: r.danado || r.faltante ? "#dc2626" : "#94a3b8" }}>
                              {r.danado} / {r.faltante}
                            </td>
                            <td style={{ ...num, fontWeight: 700, color: r.porEntregar ? "#b45309" : "#16a34a" }}>
                              {r.porEntregar}
                            </td>
                            {captura ? (
                              r.porEntregar > 0 ? (
                                ["entregado", "danado", "faltante"].map((campo) => (
                                  <td key={campo}>
                                    <Input
                                      bsSize="sm"
                                      type="number"
                                      min="0"
                                      max={r.porEntregar}
                                      step="any"
                                      style={{ width: "72px", textAlign: "right" }}
                                      value={(capturaEntrega[r._id] || {})[campo] || ""}
                                      onChange={(e) => capturaRenglon(r._id, campo, e.target.value)}
                                    />
                                  </td>
                                ))
                              ) : (
                                <td colSpan={3} style={{ color: "#16a34a", fontSize: "0.8rem", whiteSpace: "nowrap" }}>
                                  Entregado completo
                                </td>
                              )
                            ) : null}
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </div>
                );
              })()}

              {user.entregas_registrar && infoEntregas.renglones.some((r) => r.porEntregar > 0) ? (
                <div style={{ border: "1px solid #e2e8f0", borderRadius: "8px", padding: "10px", marginBottom: "12px" }}>
                  <Row>
                    <Col md={3}>
                      <Label>Fecha de entrega</Label>
                      <Input
                        type="date"
                        value={datosEntrega.fecha}
                        onChange={(e) => setDatosEntrega({ ...datosEntrega, fecha: e.target.value })}
                      />
                    </Col>
                    <Col md={3}>
                      <Label>Recibio</Label>
                      <Input
                        value={datosEntrega.recibio}
                        onChange={(e) => setDatosEntrega({ ...datosEntrega, recibio: e.target.value })}
                      />
                    </Col>
                    <Col md={6}>
                      <Label>Observaciones</Label>
                      <Input
                        value={datosEntrega.observaciones}
                        onChange={(e) => setDatosEntrega({ ...datosEntrega, observaciones: e.target.value })}
                      />
                    </Col>
                  </Row>
                  <br />
                  <Label>Acuse firmado (foto o PDF; puede ser mas de uno)</Label>
                  <SelectorArchivos archivos={acusesNuevos} onChange={setAcusesNuevos} />
                  <div style={{ display: "flex", gap: "6px", marginTop: "8px" }}>
                    <Button size="sm" color="secondary" outline onClick={entregaTodo}>
                      Todo lo pendiente
                    </Button>
                    <Button size="sm" color="success" disabled={guardandoEntrega} onClick={guardaEntrega}>
                      {guardandoEntrega ? "Guardando..." : "Registrar entrega"}
                    </Button>
                  </div>
                </div>
              ) : null}

              <h6>Entregas registradas</h6>
              {infoEntregas.entregas.length ? (
                <Table size="sm" borderless>
                  <thead>
                    <tr>
                      <th>Fecha</th>
                      <th>Registro</th>
                      <th>Recibio</th>
                      <th>Detalle</th>
                      <th>Acuses</th>
                    </tr>
                  </thead>
                  <tbody>
                    {[...infoEntregas.entregas].reverse().map((e) => (
                      <tr key={e._id}>
                        <td style={{ whiteSpace: "nowrap" }}>{e.fecha}</td>
                        <td>{e.user}</td>
                        <td>{e.recibio}</td>
                        <td style={{ fontSize: "0.85rem" }}>
                          {e.renglones
                            .map(
                              (x) =>
                                `${x.SKU}: ${x.entregado}${x.danado ? ` (+${x.danado} danado)` : ""}${x.faltante ? ` (+${x.faltante} faltante)` : ""}`
                            )
                            .join(" · ")}
                          {e.observaciones ? <div style={{ color: "#64748b" }}>{e.observaciones}</div> : null}
                        </td>
                        <td>
                          {(e.acuses || []).map((x) => (
                            <div key={x._id}>
                              <a href={x.url} target="_blank" rel="noopener noreferrer">
                                <i class="far fa-file"></i> {x.nombre}
                              </a>
                            </div>
                          ))}
                          {user.entregas_registrar ? (
                            <Button size="sm" color="link" onClick={() => agregaAcuse(e._id)}>
                              + acuse
                            </Button>
                          ) : null}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <small style={{ color: "#64748b" }}>Todavia no hay entregas registradas.</small>
              )}
            </>
          )}
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleEntregas}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="lg" isOpen={modalArchivosNota} toggle={toggleArchivosNota}>
        <ModalHeader toggle={toggleArchivosNota}>
          <h4>Imagenes y archivos · Nota {notaArchivos.numero}</h4>
          <small style={{ color: "#64748b" }}>{notaArchivos.clientes}</small>
        </ModalHeader>
        <ModalBody>
          {archivosNota.length ? (
            <div style={{ display: "flex", flexWrap: "wrap", gap: "12px" }}>
              {archivosNota.map((f) => (
                <div
                  key={f._id}
                  style={{
                    width: "150px",
                    border: seleccionQuitar.includes(f._id) ? "2px solid #dc2626" : "1px solid #e2e8f0",
                    borderRadius: "8px",
                    padding: "6px",
                    fontSize: "12px",
                  }}
                >
                  <a href={f.url} target="_blank" rel="noopener noreferrer">
                    {esImagen(f) ? (
                      <img
                        src={f.url}
                        alt={f.nombre}
                        style={{ width: "100%", height: "100px", objectFit: "cover", borderRadius: "4px" }}
                      />
                    ) : (
                      <div style={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <i class="far fa-file fa-3x"></i>
                      </div>
                    )}
                  </a>
                  <div style={{ wordBreak: "break-all", marginTop: "4px" }}>{f.nombre}</div>
                  <div style={{ color: "#64748b" }}>
                    {f.fecha} {f.user}
                  </div>
                  <label style={{ margin: 0 }}>
                    <input
                      type="checkbox"
                      checked={seleccionQuitar.includes(f._id)}
                      onChange={(e) =>
                        setSeleccionQuitar(
                          e.target.checked
                            ? [...seleccionQuitar, f._id]
                            : seleccionQuitar.filter((x) => x !== f._id)
                        )
                      }
                    />{" "}
                    Quitar
                  </label>
                </div>
              ))}
            </div>
          ) : (
            <p style={{ color: "#64748b" }}>Esta nota todavia no tiene imagenes ni archivos.</p>
          )}
          <hr />
          <SelectorArchivos archivos={archivosNuevos} onChange={setArchivosNuevos} />
        </ModalBody>
        <ModalFooter>
          {seleccionQuitar.length ? (
            <Button color="danger" onClick={quitaArchivosNota}>
              Quitar {seleccionQuitar.length}
            </Button>
          ) : null}
          <Button color="success" disabled={!archivosNuevos.length} onClick={subeArchivosNota}>
            Subir
          </Button>
          <Button color="secondary" onClick={toggleArchivosNota}>
            Cerrar
          </Button>
        </ModalFooter>
      </Modal>

      <Modal size="xxl" isOpen={modalEntregar} toggle={toggleEntregar}>
        <ModalHeader toggle={toggleEntregar}>
          <h4>Entregar Guias</h4>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col md={3}>
              <Label className="mr-sm-2">Paqueteria</Label>
              <Input
                className="col-sm-12"
                bsSize="sm"
                type="select"
                value={selectedPaqueteria}
                required
                onChange={(e) => {
                  jalaPaqueteria(e.target.value);
                }}
              >
                <option value="">Selecciona</option>
                {paqueterias
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return <option value={a._id}>{a.name}</option>;
                  })}
              </Input>
            </Col>
            
          </Row>
          <br />

                   {/* Tabla Surtidos */}

            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Codigo</Label>
              </Col>
              <Col md={4}>
                <Label className="mr-sm-2">Surtido</Label>
              </Col>
              <Col md={5}>
                <Label className="mr-sm-2">Cliente</Label>
              </Col>
            </Row>

            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="_id"
                      type="string"
                      value={inputField._id}
                      onChange={(event) => {
                        BuscaArticulo(inputField.id, event);
                      }}
                    ></Input>
                  </Col>
                  <Col md={4}>
                    <Input
                      bsSize="sm"
                      name="articulo"
                      type="string"
                      value={inputField.articulo}
                      disabled
                    ></Input>
                  </Col>
                  <Col md={5}>
                    <Input
                      bsSize="sm"
                      name="cliente"
                      type="string"
                      value={inputField.cliente}
                      disabled
                    ></Input>
                  </Col>

                  {/* <Col>
                    <Button
                      title="Quitar renglon"
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      title="Agregar renglon"
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col> */}
                </Row>
              </div>
            ))}



          <Button
            size="sm"
            color="success"
            onClick={(e) => saveEntregar()}
            tabindex="-1"
          >
            Guardar
          </Button>
        </ModalBody>
      </Modal>
      <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
    <ModalHeader toggle={toggleProgreso}>
      <h4>Progreso</h4>
    </ModalHeader>
    <ModalBody>
     <h4> Este proceso puede tardar varios segundos.
      <br />
      Por favor no cierre ni refresque su navegador.
      </h4>
      <br />
      <div className="progreso">
          <Spinner
            style={{
              width: "50px",
              height: "50px",
              color: "#232B41",
            }}
          />
          <Spinner
            style={{
              width: "50px",
              height: "50px",
              color: "#232B41",
            }}
          />
          <Spinner
            style={{
              width: "50px",
              height: "50px",
              color: "#232B41",
            }}
          />
      </div>
    </ModalBody>
  </Modal>
      {loader}
    </>
  );
}

export default ListadoSurtidos;
